module.exports = __webpack_public_path__ + "static/media/fransclaus.aa5d4684.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/fransclaus.webp
// module id = 486
// module chunks = 0